<template>
   <div class="home">
      <div class="banner outer">
        <div class="inside1490">
            <h1 class="title_1">易猎云专注于</h1>
            <h1 class="title_2">组织招聘效能提升</h1>
        </div>
      </div>
      <div class="tabbar outer">
        <div class="inside1490">
            <div class="tab_chilcd">
                <div class="tab_item">
                    <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_62%25%402x.png"/>
                    <p>提升招聘效率</p>
                </div>
                <div class="tab_item">
                    <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_151%25%402x.png"/>
                    <p>提升管理效率</p>
                </div>
                <div class="tab_item">
                    <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_39%25%402x.png"/>
                    <p>降低成本</p>
                </div>
                <div class="tab_item">
                    <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_310%25%402x.png"/>
                    <p>员工体验提升</p>
                </div>
            </div>
        </div>
      </div>
      <!--招聘全流程数字化管理-->
      <div class="whole_box outer">
        <div class="inside1490">
            <h2>招聘全流程数字化管理</h2>
            <div class="whole_child">
                <div class="whole_item">
                    <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_recruit_01%402x.png"/>
                    <p>岗位投放</p>
                    <img class="icon_right" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mk_arrow_to_right.gif"/>
                </div>
                <div class="whole_item">
                    <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_recruit_02%402x.png"/>
                    <p>简历入库</p>
                    <img class="icon_right" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mk_arrow_to_right.gif"/>
                </div>
                <!-- <div class="whole_item">
                    <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_recruit_03%402x.png"/>
                    <p>人岗匹配</p>
                    <img class="icon_right" src="https://images.36w.cn/officialWebImagse/icon_right_arrow@3x.png"/>
                </div> -->
                <div class="whole_item">
                    <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_recruit_04%402x.png"/>
                    <p>邀约</p>
                    <img class="icon_right" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mk_arrow_to_right.gif"/>
                </div>
                <div class="whole_item">
                    <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_recruit_05%402x.png"/>
                    <p>面试</p>
                    <img class="icon_right" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mk_arrow_to_right.gif"/>
                </div>
                <div class="whole_item">
                    <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_recruit_06%402x.png"/>
                    <p>Offer</p>
                    <img class="icon_right" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mk_arrow_to_right.gif"/>
                </div>
                <div class="whole_item">
                    <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_recruit_07%402x.png"/>
                    <p>入职</p>
                </div>
            </div>
        </div>
      </div>
      <!--易猎云主要产品-->
      <div class="mainpro outer">
        <div class="inside1490">
            <h2>易猎云主要产品</h2>
            <div class="mainprochild">
                <div class="mainpro_item">
                    <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_01%402x.png"/>
                    <h3>RPO招聘管理系统</h3>
                    <p>易猎云RPO招聘管理系统专注于招聘效率提升，主要帮助RPO企业解决批量招聘的效率、管理、渠道以及内部协同等问题，RPO小微企业永久免费</p>
                    <span class="item_detail" @click="todoprodect('1')">详情 ></span>
                </div>
                <div class="mainpro_item">
                    <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_02%402x.png"/>
                    <h3>HR招聘管理系统</h3>
                    <p>易猎云HR招聘管理系统主要服务于中大型企业招聘团队，帮助企业解决人才库建设，私域流量，内部推荐，招聘效率提升，多角色协同等</p>
                    <span class="item_detail" @click="todoprodect('2')">详情 ></span>
                </div>
                <div class="mainpro_item">
                    <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_03%402x.png"/>
                    <h3>HRO外包管理系统</h3>
                    <p>服务于人力资源公司外包业务，实现员工的入职办理，花名册，电子合同签定，社保/商保增减员，智能算薪，发薪和报税等一站式服务</p>
                    <span class="item_detail" @click="todoprodect('3')">详情 ></span>
                </div>
                <div class="mainpro_item">
                    <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_04%402x.png"/>
                    <h3>企微助手</h3>
                    <p>服务于招聘场景的企业微信侧边栏，将企微好友和易猎云招聘管理系统打通，可展示候选人信息，职位信息，安排面试等功能</p>
                    <span class="item_detail" @click="todoprodect('4')">详情 ></span>
                </div>
                <div class="mainpro_item">
                    <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_05%402x.png"/>
                    <h3>易分享</h3>
                    <p>私域分享裂变小程序，可以把职位分享给好友，群和朋友圈，分享后求职者投递简历后会自动进入易猎云人才库，支持内推，支持以企业的主体独立部署</p>
                    <!-- <span class="item_detail" @click="todoprodect('5')">详情 ></span> -->
                </div>
                <div class="mainpro_item">
                    <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_06%402x.png"/>
                    <h3>易外呼APP</h3>
                    <p>基于android平台的外呼APP，可在易猎云系统中对候选人进行一键外呼，一键短信发送，自动通话录音及通话统计等功能</p>
                    <span class="item_detail" @click="todoprodect('6')">详情 ></span>
                </div>
            </div>
        </div>
      </div>
      <!--易猎云产品优势-->
      <div class="advantages outer">
        <div class="inside1490">
            <p class="adv_title">易猎云产品优势</p>
            <div class="advantages_child">
                <div class="advantages_item">
                    <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_grasp%20the%20deepening%402x.png"/>
                    <h3>领域深耕</h3>
                    <p class="adv_txt">管理团队均出自国内头部人力资源企业，具备10年以上的行业纵深经验，对招聘和外包业务的本质有更深的理解</p>
                </div>
                <div class="advantages_item">
                    <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_technical%20advantage%402x.png"/>
                    <h3>技术优势</h3>
                    <p class="adv_txt">技术人员大部分来自BAT等一线互联网公司及智联招聘、北森等人力资源公司，拥有丰富的人力资源系统架构设计经验</p>
                </div>
                <div class="advantages_item">
                    <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_advantage%20of%20service%402x.png"/>
                    <h3>服务优势</h3>
                    <p class="adv_txt">专属的客户成功团队，结合客户的业务制定专属的培训方案，在使用产品的过程中遇到任何问题都能第一时间跟进及解决</p>
                </div>
            </div>
        </div>
      </div>
      <!--媒体报道-->
      <div class="outer media">
        <h2>媒体报道</h2>
        <div class="media_child inside1490">
            <div class="media_item1">
                <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/pic_report_02%402x.png"/>
                <p class="media_item_title">易猎云开创RPO数字化3.0时代,小微企业永久免费</p>
                <p class="media_item_txt">近年来，中国作为快速发展的新兴人力资源服务市场，市场规模持续快速增长。根据中智咨询...</p>
                <div class="media_item_bottom">
                    <p class="item_left">2022-05-17</p>
                    <p class="item_right"><a @click="todomedia('/coverage/5')">详情</a> ></p>
                </div>
            </div>
            <div class="media_item1">
                <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/pic_report_01%402x.png"/>
                <p class="media_item_title">RPO数字化趋势下「易猎云」想要为万亿主流市场造一个“工作系统”</p>
                <p class="media_item_txt">打通数据平台，支持私域获客，RPO员工效能方可被充分展现。
                    据国家统计局数据，截止2020年...</p>
                <div class="media_item_bottom">
                    <p class="item_left">2022-05-18</p>
                    <p class="item_right"><a  @click="todomedia('/coverage/2')">详情</a> ></p>
                </div>
            </div>
            <div class="media_item2">
                <div class="media_bt">
                    <span class="bt_icon"></span>
                    <span class="bt_title">新闻动态</span>
                </div>
                <div class="media_textbox">
                    <div class="textbox_left">
                        <p class="textbox_left_num">17</p>
                        <p class="textbox_left_date">2022/05</p>
                    </div>
                    <div class="textbox_right">
                        <a  @click="todomedia('/coverage/1')" style="color: #1D2754;">易猎云开启RPO3.0时代，人力管理平台是怎样进行数字化转型的？</a>
                    </div>
                </div>
                <div class="bottom_hr"></div>
                <div class="media_textbox">
                    <div class="textbox_left">
                        <p class="textbox_left_num">26</p>
                        <p class="textbox_left_date">2022/05</p>
                    </div>
                    <div class="textbox_right">
                        <a  @click="todomedia('/coverage/4')" style="color: #1D2754;" > 批量招聘难题何解？他们发现了HRSaaS的新机会</a>
                    </div>
                </div>
                <div class="bottom_hr"></div>
                <div class="media_textbox">
                    <div class="textbox_left">
                        <p class="textbox_left_num">19</p>
                        <p class="textbox_left_date">2022/05</p>
                    </div>
                    <div class="textbox_right">
                        <a  @click="todomedia('/coverage/3')" style="color: #1D2754;" >最有前景的RPO数字化趋势来到了，工作系统是怎么逆袭的？</a>
                    </div>
                </div>
            </div> 
        </div>
      </div>
      <!--安全保障-->
      <div class="measures outer">
        <h2>安全保障</h2>
        <div class="measures_child inside1490">
            <div class="measures_item">
                <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/icon_safe01%402x.png"/>
                <h3>权威认证</h3>
                <p style="margin-top: 60px;">ISO9001质量管理体系认证</p>
                <p>ISO27001信息安全管理体系认证</p>
            </div>
            <div class="measures_item">
                <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/icon_safe02%402x.png"/>
                <h3>隐私保护</h3>
                <p style="margin-top: 60px;margin-left: 30px;margin-right: 30px;">未经客户授权，不会将数据用做业务外</p>
                <p style="margin-left: 30px;margin-right: 30px;" >的任何用途，不会将数据转移给第三方</p>
            </div>
            <div class="measures_item">
                <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/icon_safe03%402X.png"/>
                <h3>安全管控</h3>
                <p style="margin-top: 60px;">严格的信息安全管控机制</p>
                <p>银行级加密通信及阿里云安全支持</p>
            </div>
            <div class="measures_item">
                <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/icon_safe04%402x.png"/>
                <h3>应用安全</h3>
                <p style="margin-top: 60px;">应用级安全保障数据权限最小必须</p>
                <p>简历敏感信息加密存储及导出规范</p>
                <p></p>
            </div>
        </div>
      </div>
      <!--与更多优秀企业共同成长-->
      <div class="mxcellent outer">
        <h2>与更多优秀企业共同成长</h2>
        <div class="mxcellent_child inside1490">
            <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/pic_logo%20wall%402x.png"/>
        </div>
      </div>
      <!--即刻开启数字化招聘人效提升之旅-->
      <!-- <div class="efficiency">
        <h2>即刻开启数字化招聘人效提升之旅</h2>
        <p @click="trial()">免费试用</p>
      </div> -->
            <!--合作伙伴-->
            <div class="partner outer">
        <h2>合作伙伴</h2>
        <div class="partner__list inside1490">
          <div class="parchild">
            <img
              class="img1"
              src="https://img.yilieyun.com/front-yilieyun/official/icon_zhilianzhaopin@2x.png"
            />
          </div>
          <div class="parchild">
            <img
              class="img2"
              src="https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_qianchenwuyou@2x.png"
            />
          </div>

          <div class="parchild">
            <img
              class="img3"
              src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/logo_boss%402x.png"
            />
          </div>
          <div class="parchild">
            <img
              class="img4"
              src="https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_58@2x.png"
            />
          </div>
        </div>
      </div>
      <div class="security outer">
          <div class="inside1490 security_child">
            <div class="security_left"><img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_customer_service%402x.png"/></div>
            <div class="security_right">
              <p class="p1">即刻开启数字化招聘人效提升之旅</p>
              <div class="security_center" @click="trial()">申请试用</div>
            </div>
           
          </div>
      </div>
      <!--申请试用组件-->
    <populone :isshow="windowflag" :he="true" @handleChange="changewindow" />
   </div>
</template>
<script>
import populone from "@/components/views/popul/populone.vue";

export default {
    name: "home",
    data() {
        return{
            routeData:{},
            windowflag: false,
        }
  },
  metaInfo: {
    title: "易猎云招聘管理系统官网-RPO工作平台-小微企业免费人才库",
    meta: [
      {
        name: "keywords",
        content: "易猎云，招聘管理系统，RPO，批量招聘，免费",
      },
      {
        name: "description",
        content: "易猎云招聘管理系统，RPO公司批量招聘数字化首选的招聘系统",
      },
    ],
  },
  components: {
    populone,
  },
  mounted(){
    if (Object.keys(this.$route.query).length) {
      this.routeData = this.$route.query;
    }
    const { u = "" } = this.routeData;
    if (!u) {
      console.log("官网加载");
      zhuge.track("官网加载", {
        渠道: "pc",
        utm类型: "自然流量",
      });
    } else {
      zhuge.track("官网加载", {
        渠道: "pc",
        utm类型: "驱动流量",
      });
    }
  },
  methods:{
    trial() {
      this.windowflag = true;
    },
    changewindow(value) {
      this.windowflag = value;
    },
    todomedia(path){
            this.$router.push({
            name:path
        })
       
    },
    todoprodect(val){
        if(val=='1'){
            this.$router.push({
             path: "/product",
            });
        }else if(val=='2'){
            this.$router.push({
             path: "/product/hr",
            });
        }else if(val=='3'){
            this.$router.push({
              name: "Productoutsource",
            });
        }else if(val=='4'){
            this.$router.push({
                name: "Productwecom",
            });
        }else if(val=='5'){
            this.$router.push({
                name: "Productordering",
            });
        }else if(val=='6'){
            this.$router.push({
                name: "Productecall",
            });
        }
        document.documentElement.scrollTop = 0;
    }
  }
}
</script>
<style lang="less" scoped>
@import "~@/assets/css/style/index.less";
.home{
    margin-top: 85px;
    .banner{
        width: 100%;
        height: 720px;
        background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/banner_01_v2%402x.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding-top: 278px;
        box-sizing: border-box;
        .title_1{
            font-size: 62px;
        }
        .title_2{
            font-size: 62px;
            margin-top: 88px;
            margin-left: 70px;
        }
    }
    .tabbar{
        width: 100%;
        height: 200px;
        background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/pic_bfb%402x.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .tab_chilcd{
            display: flex;
            padding-left: 90px;
            padding-right: 90px;
            box-sizing: border-box;
            justify-content: space-between;
            .tab_item{
                width: 144px;
                height: 134px;
                margin-top: 54px;
                text-align: center;
                img{
                    width: 100px;
                    height: 36px;
                    margin: 0 auto;
                }
                p{
                    font-size: 24px;
                    color: #FFFFFF;
                    margin-top: 37px;
                }
            }
        }
    }
    .whole_box{
        width: 100%;
        height: 512px;
        background: #F2F5FB;
        padding-top: 77px;
        box-sizing: border-box;
        h2{
            font-size: 48px;
            color: #1D2754;
            text-align: center;
        }
        .whole_child{
            display: flex;
            margin-top: 85px;
            justify-content: space-between;
            .whole_item{
                position: relative;
                width: 173px;
                height: 249px;
                background: #FFFFFF;
                border-radius: 10px;
                img{
                    width: 103px;
                    height: 103px;
                    margin: 0 auto;
                    margin-top: 49px;
                }
                p{
                    font-size: 20px;
                    color: #1D2754;
                    text-align: center;
                    margin-top: 15px;
                }
                .icon_right{
                    position: absolute;
                    width: 46px;
                    height: 19px;
                    top: 60px;
                    right: -68px;
                }
            }
        }
    }
    .mainpro{
        width: 100%;
        height: 1250px;
        background-color: #ffffff;
        padding-top: 78px;
        box-sizing: border-box;
        h2{
            font-size: 48px;
            color: #1D2754;
            text-align: center;
        }
        .mainprochild{
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .mainpro_item{
                position: relative;
                width: 441px;
                height: 476px;
                background: linear-gradient( 180deg, #EFF7FF 0%, #FFFFFF 100%);
                box-shadow: 0px 1px 9px 2px #F4F8FC;
                border-radius: 4px;
                margin-top: 56px;
                img{
                    width: 174px;
                    height: 155px;
                    margin: 0 auto;
                    margin-top: 60px;
                }
                h3{
                    font-size: 26px;
                    color: #313236;
                    text-align: center;
                    margin-top: 45px;
                }
              
                p{
                    padding-left: 36px;
                    padding-right: 36px;
                    box-sizing: border-box;
                    margin-top: 20px;
                    font-size: 18px;
                    color: #1D2754;
                    line-height: 30px;
                    text-align: justify;
                }
                .item_detail{
                    position: absolute;
                    font-size: 20px;
                    color: #137AF6;
                    right: 34px;
                    bottom: 23px;
                    cursor: pointer;
                }
                
              
            }
            .mainpro_item:hover{
                background: linear-gradient( 180deg, #80CCFF 0%, #0064EF 100%);
                h3{
                    color: #ffffff;
                }
                p{
                    color: #ffffff;
                }
                span{
                    color: #ffffff;
                }
            }
       

        }
    }
    .advantages{
        width: 100%;
        height: 576px;
        background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/bg_blue%402x.png');
        background-repeat: no-repeat;
        background-size: 100%;
        .adv_title{
            font-size: 48px;
            color: #313236;
            text-align: center;
            padding-top: 90px;
            box-sizing: border-box;
        }
        .advantages_child{
            display: flex;
            justify-content: space-between;
            margin-top: 70px;
            padding-left: 20px;
            padding-right: 20px;
            box-sizing: border-box;
            .advantages_item{
                width: 407px;
                height: 360px;
                img{
                    width: 126px;
                    height: 126px;
                    margin: 0 auto;
                }
                h3{
                    font-size: 22px;
                    color: #1D2754;
                    text-align: center;
                    margin-top: 30px;
                }
                .adv_txt{
                    font-size: 18px;
                    color: #1D2754;
                    line-height: 32px;
                    margin: 15px 5px 0px 5px;
                }
            }
        }
    }
    .media{
        width: 100%;
        height: 800px;
        background-color: #ffffff;
        padding-top: 80px;
        box-sizing: border-box;
        h2{
            font-size: 48px;
            color: #1D2754;
            text-align: center;
        }
        .media_child{
            display: flex;
            justify-content: space-between;
            margin-top: 60px;
            .media_item1{
                width: 452px;
                height: 561px;
                background: #ffffff;
                box-shadow: 2px 5px 21px 0px #E0E0EE;
                border-top-left-radius: 12px;
                border-top-right-radius: 12px;
                img{
                    width: 100%;
                    height: 252px;
                }
                .media_item_title{
                    font-size: 26px;
                    color: #1D2754;
                    line-height: 37px;
                    margin-left: 25px;
                    margin-right: 25px;
                    margin-top: 35px;
                }
                .media_item_txt{
                    font-size: 18px;
                    color: #7F8590;
                    line-height: 34px;
                    margin-left: 25px;
                    margin-right: 25px;
                    margin-top: 20px;
                }
                .media_item_bottom{
                    width: 100%;
                    height: 30px;
                    display: flex;
                    margin-top: 57px;
                    .item_left{
                        width: 135px;
                        font-size: 18px;
                        color: #979DA6;
                        line-height: 25px;
                        margin-left: 25px;
                    }
                    .item_right{
                        flex: 1;
                        text-align: right;
                        margin-right: 25px;
                        font-size: 20px;
                        color: #215FFF;
                        line-height: 25px;
                        cursor: pointer;
                        a{
                            color: #215FFF;
                        }
                    }
                }
            }
            .media_item2{
                width: 541px;
                height: 561px;
                background: #F6F8FC;
                box-shadow: 2px 5px 21px 0px #E0E0EE;
                .media_bt{
                    width: 100%;
                    height: 30px;
                    margin-top: 30px;
                    .bt_icon{
                        display: inline-block;
                        width: 5px;
                        height: 30px;
                        background: #215FFF;
                        margin-left: 30px;
                        vertical-align: middle;
                    }
                    .bt_title{
                        display: inline-block;
                        font-size: 24px;
                        color: #1D2754;
                        vertical-align: middle;
                        margin-left: 16px;
                    }
                }
                .media_textbox{
                    width: 100%;
                    height: 74px;
                    display: flex;
                    margin-top: 50px;
                    .textbox_left{
                        width: 75px;
                        margin-left: 30px;
                        .textbox_left_num{
                            font-size: 40px;
                            color: #C9CCD3;
                            line-height: 34px;
                            text-align: center;
                        }
                        .textbox_left_date{
                            font-size: 15px;
                           color: #C9CCD3;
                           text-align: center;
                           line-height: 34px;
                        }
                    }
                    .textbox_right{
                        flex: 1;
                        margin-left: 10px;
                        font-size: 22px;
                        color: #1D2754;
                        line-height: 35px;
                        margin-right: 30px;
                        margin-top: -5px;
                    }
                }
                .bottom_hr{
                    width: 454px;
                    height: 1px;
                    border: 1px solid #E4E4E4;
                    margin-left: 40px;
                    margin-top: 40px;
                }
            }
        }
    }
    .measures{
        width: 100%;
        height: 750px;
        background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/pic_safe%402x.png');
        background-repeat: no-repeat;
        background-size: 100%;
        padding-top: 80px;
        box-sizing: border-box;
        h2{
            font-size: 40px;
            color: #FFFFFF;
            text-align: center;
        }
        .measures_child{
            display: flex;
            justify-content: space-between;
            margin-top: 60px;
            .measures_item{
                width: 346px;
                height: 452px;
                background: #052759;
                border-radius: 12px;
                border: 1px solid #3F87F0;
                img{
                    width: 126px;
                    height: 126px;
                    margin:0 auto;
                    margin-top: 46px;
                }
                h3{
                    font-size: 32px;
                    color: #FFFFFF;
                    text-align: center;
                    margin-top: 35px;
                }
                p{
                    font-size: 16px;
                    color: #FFFFFF;
                    line-height: 40px;
                    margin-left: 57px;
                    margin-right: 44px;
                    
                }
            }
        }
    }
    .mxcellent{
        width: 100%;
        height: 834px;
        background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/pic_05%402x.png');
        background-repeat: no-repeat;
        background-size: 100%;
        padding-top: 80px;
        box-sizing: border-box;
        h2{
            font-size: 40px;
            color: #FFFFFF;
            text-align: center;
        }
        .mxcellent_child{
            height:617px;
            background-color: #ffffff;
            margin-top: 50px;
            padding: 40px;
            box-sizing: border-box;
            img{
                width: 100%;
                height: 100%;
            }
        }
    }
    .efficiency{
        width: 100%;
        height: 658px;
        background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/pic_bg%402x.png');
        background-repeat: no-repeat;
        background-size: 103%;
        background-position: -10px;
        padding-top: 258px;
        box-sizing: border-box;
        h2{
            font-size: 70px;
            color: #FFFFFF;
            text-align: center;
        }
        p{
            width: 250px;
            height: 80px;
            background: #2772F0;
            border-radius: 7px;
            font-size: 26px;
            color: #FFFFFF;
            text-align: center;
            line-height: 80px;
            cursor: pointer;
            margin: 0 auto;
            margin-top: 119px;
        }
    }
    .partner{
        width: 100%;
        height: 344px;
        background: #ffffff;
        padding-top: 65px;
        box-sizing: border-box;
            h2 {
                font-size: 40px;
                font-weight: 500;
                color: #1d2754;
                line-height: 44px;
                text-align: center;
            }
            .partner__list {
                display: flex;
                height: 106px;
                justify-content: space-between;
                margin-top: 68px;
                    .parchild {
                       width: 240px;
                       height: 81px;
                       border-radius: 10px;
                       border: 1px solid #D9DAE5;
                        .img1 {
                            width: 200px;
                            height: 53px;
                            margin: 0 auto;
                            margin-top: 15px;
                            }

                        .img2 {
                            width: 171px;
                            height: 75px;
                            margin: 0 auto;
                            margin-top: 3px;
                            }

                        .img3 {
                            width: 150px;
                            height: 37px;
                            margin: 0 auto;
                            margin-top: 20px;
                            }

                        .img4 {
                            width: 195px;
                            height: 80px;
                            margin: 0 auto;
                            }
                    }
        }

    }
    .security{
      width: 100%;
      height: 277px;
      background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/bg_01%402x.png');
      background-repeat: no-repeat;
      background-size: 100% 102%;
      padding-top: 53px;
      box-sizing: border-box;
      .security_child{
        display: flex;
        .security_left{
            margin-left: 197px;
              img{
                width: 145px;
                height: 128px;
              }
        }
        .security_right{
             margin-left: 37px;
              .p1{
              display: inline-block;
              font-size: 48px;
              font-weight: 500;
              color: #ffffff;
              text-align: left;
              margin-top: 47px;
          }
        }
        .security_center{
          width: 158px;
          height: 60px;
          background: #FFFFFF;
          border-radius: 7px;
          line-height: 60px;
          text-align: center;
          font-size: 24px;
          color: #215FFF;
          cursor: pointer;
          margin: 0 auto;
          margin-top: 40px;
        }
      }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/home/home.vue